import { Link, useNavigate } from "react-router-dom";

export default function AccessDenied() {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate("/");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-6">
      <div className="bg-white rounded-xl shadow p-8 max-w-md w-full text-center">
        <h1 className="text-3xl font-bold text-red-600 mb-3">403</h1>
        <h2 className="text-xl font-semibold mb-2">Access Denied</h2>
        <p className="text-gray-600 mb-6">
          You do not have permission to view this page.
        </p>
        <div className="flex items-center justify-center gap-3">
          <button
            onClick={handleBack}
            className="px-5 py-2 rounded border border-gray-300 hover:bg-gray-50"
          >
            Back
          </button>
          <Link
            to="/"
            className="inline-block px-5 py-2 rounded bg-green-700 text-white hover:bg-green-800"
          >
            Go to Login
          </Link>
        </div>
      </div>
    </div>
  );
}
